import { render, staticRenderFns } from "./SelectItem.vue?vue&type=template&id=149e2e98&scoped=true&"
import script from "./SelectItem.vue?vue&type=script&lang=js&"
export * from "./SelectItem.vue?vue&type=script&lang=js&"
import style0 from "./SelectItem.vue?vue&type=style&index=0&id=149e2e98&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "149e2e98",
  null
  
)

export default component.exports
import QSelect from 'quasar/src/components/select/QSelect.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QSelect});
